import RecentActivityRentalCar from './RecentActivityRentalCar'

export default RecentActivityRentalCar
